var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 72,
    viewBox: "0 0 64 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2039_16444)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9966 8.00001L32.0034 8C37.1724 8.00587 42.1281 10.0619 45.7831 13.7169C49.4382 17.372 51.4941 22.3276 51.5 27.4966L51.5 27.5C51.5 35.6059 47.2203 42.4817 43.2018 47.1891C39.1542 51.9304 35.031 54.8714 34.5819 55.1852C33.8252 55.7153 32.9238 55.9996 32 55.9996C31.0771 55.9996 30.1764 55.7158 29.4203 55.1867L29.4181 55.1852L31.1388 52.729L29.4224 55.1882L29.4203 55.1867C28.9822 54.8808 24.8523 51.938 20.7982 47.1891C16.7797 42.4817 12.5 35.6059 12.5 27.5V27.4966C12.5059 22.3276 14.5618 17.372 18.2169 13.7169C21.8719 10.0619 26.8276 8.00587 31.9966 8.00001Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 11C27.6255 11.005 23.4315 12.7449 20.3382 15.8382C17.2449 18.9315 15.505 23.1255 15.5 27.5C15.5 41.6188 30.5 52.2819 31.1394 52.7281C31.3916 52.9048 31.6921 52.9996 32 52.9996C32.3079 52.9996 32.6084 52.9048 32.8606 52.7281C33.5 52.2819 48.5 41.6188 48.5 27.5C48.495 23.1255 46.7551 18.9315 43.6618 15.8382C40.5685 12.7449 36.3745 11.005 32 11ZM32 21.5C33.1867 21.5 34.3467 21.8519 35.3334 22.5112C36.3201 23.1705 37.0892 24.1075 37.5433 25.2039C37.9974 26.3003 38.1162 27.5067 37.8847 28.6705C37.6532 29.8344 37.0818 30.9035 36.2426 31.7426C35.4035 32.5818 34.3344 33.1532 33.1705 33.3847C32.0067 33.6162 30.8003 33.4974 29.7039 33.0433C28.6075 32.5892 27.6705 31.8201 27.0112 30.8334C26.3519 29.8467 26 28.6867 26 27.5C26 25.9087 26.6321 24.3826 27.7574 23.2574C28.8826 22.1321 30.4087 21.5 32 21.5Z",
    fill: "#E82026"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2039_16444",
    x: 0.5,
    y: 0,
    width: 63,
    height: 71.9995,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2039_16444"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2039_16444",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/mapMarker.ffea054f168f991c2a694eb7c297e978.svg";
export { ForwardRef as ReactComponent };